// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jSgC","col":"styles_col__2mtpq"};